module.exports = __webpack_public_path__ + "assets/img2.7276bd42.jpg";